import spaceBookingService from '../../services/spaceBookingService';
import paymentService from '../../services/paymentService';

const state = {
  bookings: [],
  loading: false,
  error: null
};

const getters = {
  allSpaceBookings: state => state.bookings
};

const actions = {
  async fetchSpaceBookings({ commit }, filters = {}) {
    commit('SET_LOADING', true);
    try {
      const response = await spaceBookingService.getSpaceBookings(filters);
      console.log('Bookings API Response:', response);
      if (response.success && response.data ) {
        commit('SET_BOOKINGS', response.data);
      } else {
        commit('SET_BOOKINGS', []);
      }
      commit('SET_LOADING', false);
      return response;
    } catch (error) {
      console.error('Store error:', error);
      commit('SET_ERROR', error);
      commit('SET_LOADING', false);
      throw error;
    }
  },

  async addSpaceBooking({ dispatch }, bookingData) {
    try {
      const response = await spaceBookingService.addSpaceBooking(bookingData);
      if (response.success) {
        await dispatch('fetchSpaceBookings');
      }
      return response;
    } catch (error) {
      console.error('Error adding booking:', error);
      throw error;
    }
  },

  async updateSpaceBooking({ dispatch }, { id, bookingData }) {
    try {
      const response = await spaceBookingService.updateSpaceBooking(id, bookingData);
      if (response.success) {
        await dispatch('fetchSpaceBookings');
      }
      return response;
    } catch (error) {
      console.error('Error updating booking:', error);
      throw error;
    }
  },

  async deleteSpaceBooking({ dispatch }, bookingId) {
    try {
      const response = await spaceBookingService.deleteSpaceBooking(bookingId);
      if (response.success) {
        await dispatch('fetchSpaceBookings');
      }
      return response;
    } catch (error) {
      console.error('Error deleting booking:', error);
      throw error;
    }
  },
  
  async getPayments(_, params) {
    try {
      const response = await paymentService.getPayments({
        bookingId: params.bookingId,
        paymentable_type: 'App\\Models\\SpaceBooking'
      });
      return response;
    } catch (error) {
      console.error('Error fetching payments:', error);
      throw error;
    }
  },
  
  async addPayment(_, paymentData) {
    try {
      const response = await paymentService.createPayment(paymentData);
      return response;
    } catch (error) {
      console.error('Error adding payment:', error);
      throw error;
    }
  },
  
  async deletePayment(_, params) {
    try {
      const response = await paymentService.deletePayment(params.paymentId);
      return response;
    } catch (error) {
      console.error('Error deleting payment:', error);
      throw error;
    }
  }
};

const mutations = {
  SET_BOOKINGS(state, bookings) {
    console.log('Setting bookings in store:', bookings);
    state.bookings = bookings;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}; 